import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  UnauthContainer, UnauthHeader, UnauthImage, UnauthText, UnauthWrapper,
} from './notFoundElements';
import { CarbonButton } from '../../Utils/generalStyles';
import img1 from '../../Images/NotFound/notfound.svg';

const index = () => {
  const navigate = useNavigate();
  return (
    <UnauthContainer>
      <UnauthWrapper>
        <UnauthImage src={img1} alt="unauth" />
        <UnauthHeader>Not Found</UnauthHeader>
        <UnauthText>The page you have been looking for is not found</UnauthText>
        <CarbonButton colored onClick={() => navigate('/')}>Back to Home</CarbonButton>
      </UnauthWrapper>
    </UnauthContainer>
  );
};

export default index;
